import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeUnderscore',
    standalone: false
})
export class RemoveUnderscorePipe implements PipeTransform {
  transform(value: string, replacement = ' '): string {
    return value?.replace(/_/g, replacement);
  }
}
